"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const octopod_auth_1 = require("@produits-internes-oss/octopod-auth");
const client_1 = require("react-dom/client");
const styled_components_1 = __importDefault(require("styled-components"));
const useRouter_1 = require("./contexts/useRouter/useRouter");
const useStore_1 = require("./contexts/useStore/useStore");
const Affinity_1 = require("./entities/Affinity/Affinity");
const Group_1 = require("./entities/Group/Group");
const Person_1 = require("./entities/Person/Person");
const Skill_1 = require("./entities/Skill/Skill");
const AffinityList_1 = require("./screens/AffinityList/AffinityList");
const Role_1 = require("./entities/Role/Role");
const GroupList_1 = require("./screens/GroupList/GroupList");
const GroupView_1 = require("./screens/GroupView/GroupView");
const Certifier_1 = require("./entities/Certifier/Certifier");
const PersonView_1 = require("./screens/PersonView/PersonView");
const SearchView_1 = require("./screens/SearchView/SearchView");
const SkillList_1 = require("./screens/SkillList/SkillList");
const SkillView_1 = require("./screens/SkillView/SkillView");
const RoleView_1 = require("./screens/RoleView/RoleView");
const JobView_1 = require("./screens/JobView/JobView");
const WorkshopList_1 = require("./screens/WorkshopList/WorkshopList");
const app_1 = require("./app");
const localization_1 = require("./localization");
global.styled = styled_components_1.default;
document.addEventListener('DOMContentLoaded', () => (0, client_1.createRoot)(document.getElementById('root')).render((0, jsx_runtime_1.jsx)(octopod_auth_1.Authenticator.Provider, { children: (0, jsx_runtime_1.jsx)(useStore_1.Store.Provider, { entities: { affinities: Affinity_1.Affinity, groups: Group_1.Group, people: Person_1.Person, skills: Skill_1.Skill, roles: Role_1.Role, certifiers: Certifier_1.Certifier }, children: (0, jsx_runtime_1.jsx)(useRouter_1.Router.Provider, { localization: { error: localization_1.localization.error, unknown: localization_1.localization.unknown }, routes: {
                '/groups': () => (0, jsx_runtime_1.jsx)(GroupList_1.GroupList, {}),
                '/groups/:id': ({ parameters }) => (0, jsx_runtime_1.jsx)(GroupView_1.GroupView, { slug: parameters[':id'] }),
                '/people/:id': ({ parameters }) => (0, jsx_runtime_1.jsx)(PersonView_1.PersonView, { slug: parameters[':id'] }),
                '/people/:id/affinities': ({ parameters }) => (0, jsx_runtime_1.jsx)(AffinityList_1.AffinityList, { slug: parameters[':id'] }),
                '/skills': () => (0, jsx_runtime_1.jsx)(SkillList_1.SkillList, {}),
                '/skills/:id': ({ parameters }) => (0, jsx_runtime_1.jsx)(SkillView_1.SkillView, { id: parseInt(parameters[':id']) }),
                '/workshops': () => (0, jsx_runtime_1.jsx)(WorkshopList_1.WorkshopList, {}),
                '/search': () => (0, jsx_runtime_1.jsx)(SearchView_1.SearchView, {}),
                '/search/:search': ({ parameters }) => (0, jsx_runtime_1.jsx)(SearchView_1.SearchView, { search: decodeURI(parameters[':search']) }),
                '/roles/:id': ({ parameters }) => (0, jsx_runtime_1.jsx)(RoleView_1.RoleView, { id: parseInt(parameters[':id']) }),
                '/jobs/:slug': ({ parameters }) => (0, jsx_runtime_1.jsx)(JobView_1.JobView, { slug: (decodeURI(parameters[':slug'])) }),
            }, redirects: {
                '/': '/groups',
                '/districts': '/groups',
                '/quartiers': '/groups',
                '/skills/matrix': '/people/me/affinities',
                '/teams': '/groups',
                '/users/:id': '/people/:id',
            }, children: (0, jsx_runtime_1.jsx)(app_1.App, {}) }) }) })));
//# sourceMappingURL=main.js.map